import { render, staticRenderFns } from "./LinkToFakturabank.vue?vue&type=template&id=cb1e9e7e&scoped=true&"
import script from "./LinkToFakturabank.vue?vue&type=script&lang=ts&"
export * from "./LinkToFakturabank.vue?vue&type=script&lang=ts&"
import style0 from "./LinkToFakturabank.vue?vue&type=style&index=0&id=cb1e9e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1e9e7e",
  null
  
)

export default component.exports